<script setup>
import { computed } from "vue"

const apiBase = useApiBase()
const apiUrl = apiBase ? `${apiBase}/api/cta/` : "/api/cta/"
const { data } = await useFetch(apiUrl, { key: "home-cta" })

const resolveImageUrl = (url) => {
  if (!url) return ""
  if (/^https?:\/\//i.test(url)) return url
  if (url.startsWith("/media/")) return url
  return url
}

const sectionData = computed(() => data.value?.section || null)
const titleWords = computed(() => {
  if (!sectionData.value) return []
  return sectionData.value.title_prefix.split(" ").filter(Boolean)
})
</script>

<template>
  <section v-if="sectionData" class="section-cta">
    <h2 class="cta-title" :aria-label="`${sectionData.title_prefix} ${sectionData.title_accent}`">
      <div
        v-for="word in titleWords"
        :key="word"
        class="word"
        aria-hidden="true"
        style="position: relative; display: inline-block; translate: none; rotate: none; scale: none; opacity: 1; transform: translate(0px, 0px);"
      >
        {{ word }}
      </div>
      <br>
      <span class="span-accent" style="translate: none; rotate: none; scale: none; opacity: 1; transform: translate(0px, 0px);">
        <div class="word" aria-hidden="true"
             style="position: relative; display: inline-block; translate: none; rotate: none; scale: none; opacity: 1; transform: translate(0px, 0px);">
          {{ sectionData.title_accent }}
        </div>
      </span>
    </h2>
    <div data-openform data-wf--button--variant="cta"
         class="button-classic w-variant-a222c3bd-e85f-ec01-a94f-4e1552f5a809"
         style="translate: none; rotate: none; scale: none; transform: translate(0px, 0px); opacity: 1;">
      <p>{{ sectionData.button_label }}</p>
    </div>
    <div class="cta-deco-01" style="translate: none; rotate: none; scale: none; transform: translate(0px, 0px); opacity: 1;">
      <img v-if="sectionData.deco_left" :src="resolveImageUrl(sectionData.deco_left)" loading="lazy" alt="" class="image-cover img-pc">
      <img v-if="sectionData.deco_left_mobile" :src="resolveImageUrl(sectionData.deco_left_mobile)" loading="lazy" alt="" class="image-cover img-mb">
    </div>
    <div class="cta-deco-02" style="translate: none; rotate: none; scale: none; transform: translate(0px, 0px); opacity: 1;">
      <img v-if="sectionData.deco_right" :src="resolveImageUrl(sectionData.deco_right)" loading="lazy" alt="" class="image-cover img-pc">
      <img v-if="sectionData.deco_right_mobile" :src="resolveImageUrl(sectionData.deco_right_mobile)" loading="lazy" alt="" class="image-cover img-mb">
    </div>
  </section>
</template>

<style lang="scss" scoped>
@use '/assets/scss/sections/_cta.scss';
</style>
